import React, { forwardRef } from 'react';
import { Box, createStyles, withStyles, Theme, BoxProps } from '@material-ui/core';
import createNameSpacedComponent from 'global/react/utils/ts/createNamespacedComponent';

const GridContainer = withStyles((theme: Theme) =>
	createStyles({
		root: {
			display: 'grid',
			gridTemplateColumns: '1fr',
			gridColumnGap: 0,
			gridTemplateRows: 'auto',
			gridTemplateAreas: `"search-area" "content"`,
		},
	}),
)((props: BoxProps) => <Box {...props} />);

const SearchArea = withStyles((theme: Theme) =>
	createStyles({
		root: {
			gridArea: 'search-area',
			padding: '12px',
			maxHeight: '10vh',
			display: 'flex',
			alignItems: 'center',
			zIndex: 6,
			[theme.breakpoints.up('sm')]: {
				maxHeight: '110px',
				padding: theme.spacing(3),
			},
		},
	}),
)((props: BoxProps) => <Box {...props} />);

const Content = withStyles((theme: Theme) =>
	createStyles({
		root: {
			gridArea: 'content',
			display: 'flex',
			overflowY: 'scroll',
			minHeight: 'min(930px, 90vh)',
			maxHeight: 'min(930px, 90vh)',
			position: 'relative',
		},
	}),
)(forwardRef((props: BoxProps & { ref: React.MutableRefObject<HTMLElement | undefined> }, ref) => <Box {...props} />));

export default createNameSpacedComponent(GridContainer, {
	SearchArea,
	Content,
});
